import { useState } from 'react';
import Button from 'style-guide/Button';
import { Input } from 'style-guide/Input';
import Modal from 'style-guide/Modal';
import Title from 'style-guide/Typography/Title';

const InsertUrlEmbedModal = ({ visible, onSuccess, onClose, name }) => {
  const [value, setValue] = useState('');

  return (
    <Modal
      visible={visible}
      footer={null}
      onClose={() => {
        onClose();
        setValue('');
      }}
      title={
        <Title variant={4} className='mr--96'>
          Insert {name} Video
        </Title>
      }
    >
      <Input value={value} onChange={(e) => setValue(e.target.value)} className='mb-2' placeholder={`${name} URL`} />
      <div className='row mt--16'>
        <div className='col-12 d-flex justify-content-end'>
          <Button
            variant='primary'
            onClick={() => {
              setValue('');
              onSuccess(value);
            }}
          >
            Insert
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InsertUrlEmbedModal;
